export const PRIMARY_COLOR: string = "#50cd89";